/*
Find in store functionality for product pages. This script looks for a trigger element to open a modal, 
fetches the store availability content via AJAX, and handles the modal display and interactions.
*/
(function () {
    function getSelectedVariantId(root) {
      var input = root.querySelector('input[name="id"]');
      if (input && input.value) return input.value;
  
      var select = root.querySelector('select[name="id"]');
      if (select && select.value) return select.value;
  
      return null;
    }
  
    function setTriggerEnabled(trigger, enabled) {
      if (!trigger) return;
      trigger.disabled = !enabled;
    }
  
    function openModal(modal) {
      modal.hidden = false;
      document.documentElement.classList.add('find-in-store-modal-open');
    }
  
    function closeModal(modal) {
      modal.hidden = true;
      document.documentElement.classList.remove('find-in-store-modal-open');
    }
  
    function fetchSectionHtml(handle, variantId) {
      var url = '/products/' + encodeURIComponent(handle) +
        '?variant=' + encodeURIComponent(variantId) +
        '&section_id=find-in-store-modal-content';
  
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to load store availability');
          return res.text();
        });
    }
  
    function initFindInStore(root) {
      var trigger = root.querySelector('[data-find-in-store-trigger]');
      var modal = root.querySelector('[data-find-in-store-modal]');
      if (!trigger || !modal) return;
  
      var handle = modal.getAttribute('data-product-handle');
      var content = modal.querySelector('[data-find-in-store-content]');
      var subtitle = modal.querySelector('[data-find-in-store-subtitle]');
  
      function refreshTriggerState() {
        var variantId = getSelectedVariantId(root);
        setTriggerEnabled(trigger, !!variantId);
      }

      function loadAndOpen() {
        var variantId = getSelectedVariantId(root);
        if (!variantId) return;
      
        trigger.disabled = true;
      
        fetchSectionHtml(handle, variantId)
          .then(function (html) {
            content.innerHTML = html;
      
            var subtitleValue = content.querySelector('[data-find-in-store-subtitle-value]');
            if (subtitle && subtitleValue) {
              subtitle.textContent = subtitleValue.textContent.trim();
            }
      
            openModal(modal);
          })
          .catch(function () {
            content.innerHTML = '<div class="find-in-store-content__empty">Unable to load availability. Please try again.</div>';
            openModal(modal);
          })
          .finally(function () {
            refreshTriggerState();
          });
      }
  
      trigger.addEventListener('click', function () {
        loadAndOpen();
      });
  
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-find-in-store-close]')) {
          closeModal(modal);
        }
      });
  
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal(modal);
      });
  
      root.addEventListener('change', function () {
        refreshTriggerState();
      });
  
      refreshTriggerState();
    }
  
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('form.product-single__form').forEach(function (form) {
        initFindInStore(form);
      });
    });
  })();
  